import { ReactNode, useEffect } from 'react';

import { useCurrentUser } from 'api/authentication/hooks';

import { useJourneyPresence } from '../hooks/use-journey-presence';
import { presenceStore } from '../hooks/use-journey-presence-store';

export const PresenceProvider = ({
  journeyId,
  children,
}: {
  journeyId?: string;
  children: ReactNode;
}) => {
  const currentUser = useCurrentUser();
  const { sendActionOpened, sendActionClosed } = useJourneyPresence(journeyId || '');

  useEffect(() => {
    presenceStore.setCurrentUserId(currentUser?.shortId);
  }, [currentUser?.shortId]);

  useEffect(() => {
    presenceStore.setSendFunctions(sendActionOpened, sendActionClosed);
  }, [sendActionOpened, sendActionClosed]);

  return <>{children}</>;
};

export const usePresence = () => {
  const activeUsers = presenceStore.useStore((state) => state.activeUsers);
  const actionEditors = presenceStore.useStore((state) => state.actionEditors);
  const currentUserId = presenceStore.useStore((state) => state.currentUserId);
  const sendActionOpened = presenceStore.useStore((state) => state.sendActionOpened);
  const sendActionClosed = presenceStore.useStore((state) => state.sendActionClosed);

  return {
    activeUsers,
    actionEditors,
    currentUserId,
    sendActionOpened,
    sendActionClosed,
  };
};
